module.exports = __webpack_public_path__ + "img/graph.c067127d.png";